/**
 * Could one day be published as an external module?
 */
export default {
  computed: {
    formValid() {
      const { formValidation } = this.$options;
      const valid = {};

      if (formValidation) {
        for (const prop in formValidation) {
          if (formValidation.hasOwnProperty(prop) && typeof formValidation[prop] === 'function') {
            if (this.form && this.form.hasOwnProperty(prop)) {
              try {
                valid[prop] = formValidation[prop].call(this, this.form[prop], this.form);
              } catch (err) {
                console.error(err);
                valid[prop] = 'ERROR';
              }
            } else {
              valid[prop] = null;
            }
          }
        }
      }

      return valid;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/formValidation.js